<template>
    <BasePopup @close="close" :loading="isLoading" :options="{ fixedWidth: true }">
        <div class="compatibilities">
            <h3 v-if="showDownload && (content || contentTitle)">{{ content ? content.title : contentTitle }}</h3>
            <h3 v-else-if="showDownload">{{ t.popup.compatibility_title }}</h3>
            <h3 v-else>{{ t.popup.compatibility_subtitle }}</h3>
            <aside v-if="notes && notes.length > 0" class="compatibility-notes">
                <span v-for="(note, noteIdx) in notes" :key="_uid + ':note:' + noteIdx">{{ note }}</span>
            </aside>
            <div v-if="compatibilities && compatibilities.length > 0">
                <p class="table-title">
                    <strong>{{ t.popup.compatibility_subtitle_2 }}</strong>
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>{{ t.popup.compatibility_table_1 }}</th>
                            <th>{{ t.popup.compatibility_table_2 }}</th>
                            <th>{{ t.popup.compatibility_table_3 }}</th>
                            <th>{{ t.popup.compatibility_table_4 }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(compatibility, compIdx) in compatibilities" :key="_uid + ':comp:' + compIdx">
                            <td>{{ compatibility["kindOfAssetName"] }}</td>
                            <td>{{ compatibility["fileTypeName"] }}</td>
                            <td>
                                <span v-if="compatibility['softwareName'] === null">{{ t.popup.flexible }}</span>
                                <span v-else>{{ compatibility["softwareName"] }}</span>
                            </td>
                            <td>
                                <span v-if="compatibility['softwareVersionName'] === null">{{ t.popup.flexible }}</span>
                                <span v-else>ab {{ compatibility["softwareVersionName"] }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="showDownload" style="margin-bottom: 4px;">
                <br />
                <button
                    v-if="download && download.length > 1"
                    :class="[
                        'button',
                        'button-multi-download',
                        'button-primary',
                        { 'show-download-options': showDownloadOptions },
                    ]"
                    @click="showDownloadOptions = true"
                >
                    <div class="button-multi-download-software">
                        <i
                            class="icon icon-close"
                            @click="
                                (ev) => {
                                    ev.stopPropagation()
                                    showDownloadOptions = false
                                }
                            "
                        ></i>
                        <div v-for="(file, fileIdx) in download" :key="fileIdx + '_' + file.name">
                            <template v-if="file.image_software && contentUserUrl">
                                <picture @click="goto(contentUserUrl + '/' + file.id)">
                                    <source
                                        type="image/avif"
                                        :srcset="
                                            file.image_software.url.replace(
                                                /\.(jpg|jpeg|png|gif|bmp|tiff|webp)$/i,
                                                '.avif',
                                            )
                                        "
                                    />
                                    <img
                                        type="image/webp"
                                        :alt="file.name"
                                        style="width: 18px; height: 18px"
                                        :title="file.name"
                                        loading="lazy"
                                        :src="
                                            file.image_software.url.replace(
                                                /\.(jpg|jpeg|png|gif|bmp|tiff|avif)$/i,
                                                '.webp',
                                            )
                                        "
                                    />
                                </picture>
                            </template>
                        </div>
                    </div>
                    <span class="button-label" :class="{'d-none' : showDownloadOptions}" @click="showDownloadOptions = true">{{ t.buttons.download_2 }}</span>
                </button>
                <button
                    v-else-if="download && contentUserUrl"
                    class="button button-primary button-download-content"
                    data-has-user="0"
                >
                    <span class="button-label" @click="goto(contentUserUrl)">{{ t.buttons.download_2 }}</span>
                </button>
            </div>
            <div class="content-info" v-if="sources">
                <span>{{ t.frontend.source }}: </span><span v-html="sources"></span>
            </div>
            <div class="content-info" v-if="fonts">
                <span>{{ t.frontend.fonts }}: </span><span v-html="fonts"></span>
            </div>
            <div class="content-info" v-if="content">
                <a :href="contentUrl"
                    >{{ t.popup.click_for_info }}<span v-if="packageTitle">: {{ packageTitle }}</span></a
                >
            </div>
        </div>
        <DownloadInfo :buttons="buttons" />
    </BasePopup>
</template>
<script>
import axios from "@/app/axios.ts"
import BasePopup from "@/components/Frontend/BasePopup.vue"
import DownloadInfo from "./DownloadInfo.vue"
const translationsData = window.translationsData

export default {
    components: { BasePopup, DownloadInfo },
    props: {
        contentId: {
            type: [Number, String, Boolean],
            required: true,
        },
        showDownload: {
            type: Boolean,
            default: false,
        },
        content: {
            type: [Object, Boolean],
            default: false,
        },
    },
    data() {
        return {
            notes: false,
            compatibilities: false,
            isLoading: false,
            showDownloadOptions: false,
            // content: {},
            download: [],
            buttons: [],
            limitReached: false,
            loggedIn: false,
            contentUserUrl: false,
            packageTitle: false,
            contentUrl: this.content && this.content.url ? this.content.url : false,
            contentTitle: false,
            sources: false,
            fonts: false,
            t: translationsData.translations,
        }
    },
    async mounted() {
        try {
            this.isLoading = true
            const { data } = await axios.get(
                `/${translationsData.global_route.locale}/content/${this.contentId}/compatibilities`,
            )
            this.notes = data?.notes.filter((note) => note !== null)
            this.compatibilities = data?.compatibilities
            this.limitReached = data?.limitReached
            this.download = data?.download
            this.loggedIn = data?.loggedIn
            this.contentUserUrl = data?.contentUserUrl
            this.packageTitle = data?.packageTitle
            this.contentUrl = data?.contentUrl
            this.contentTitle = data?.contentTitle
            this.sources = data?.sources
            this.fonts = data?.fonts
            this.buttons = JSON.stringify(data?.buttons)
        } catch (e) {
            // this.$error(e);
        } finally {
            this.isLoading = false
        }
    },
    methods: {
        close() {
            this.$emit("close")
        },
        goto(fileUrl) {
            window.useContent(fileUrl)
        },
    },
}
</script>
<style lang="scss" scoped>
.compatibilities {
    h3 {
        white-space: initial !important;
        font-weight: 600;
    }

    strong {
        color: var(--color-main-font);
    }

    .compatibility-notes {
        white-space: normal;
        color: rgb(68 68 70);

        > span {
            &:not(:last-child)::after {
                display: inline-block;
                margin: 0 5px;
                content: " // ";
                color: rgb(192 191 192);
            }
        }
    }

    a {
        color: var(--color-alternate);

        > span {
            color: var(--color-light-grey);
        }
    }

    .table-title {
        margin-bottom: 16px;
        margin-top: 25px;
    }

    .content-info {
        font-size: 12px;
        line-height: 15px;
        margin-top: 16px;

        a {
            color: var(--color-alternate);
        }

        > span {
            &:last-of-type {
                > a {
                    color: var(--color-alternate);
                }
            }
        }
    }

    & > h3 {
        @media (width <= 550px) {
            margin-top: 15px;
        }

        @media (width <= 576px) {
            order: unset;
        }
    }
}
</style>
